import React from "react";
import { Input, Select, ValueOpt } from "best-common-react";
import { useDropdowns } from "../../../../contexts/DropdownsContext";
import { useTranslation } from "react-i18next";

type AcademicLevelupInputProps = {
  id: string;
  idValue: number;
  writeIn?: string;
  onChange: (idValue?: number, writeIn?: string) => void;
};

const AcademicLevelupInput: React.FC<AcademicLevelupInputProps> = ({ id, idValue, writeIn, onChange }) => {
  const { t } = useTranslation(["translation", "profile"]);
  const { academicLevelsOptions } = useDropdowns();

  return (
    <div>
      <Select
        id={`${id}-select`}
        value={academicLevelsOptions.find((option) => option.value === idValue)}
        options={academicLevelsOptions}
        label={t("profile:highestGrade")}
        placeholder={t("translation:selectPlaceholder")}
        onChange={(selected: ValueOpt<number>) => {
          onChange(selected?.value, undefined);
        }}
      />
      {idValue === 4 && (
        <div className="mt-1">
          <Input
            id={`${id}-write-in`}
            className="w-100"
            value={writeIn || ""}
            onChange={(value) => onChange(idValue, value)}
            required
          />
        </div>
      )}
    </div>
  );
};

export default AcademicLevelupInput;
